<script lang="ts">
  import { user } from "@/stores/user";
  import i18n from "@/stores/i18n";

  import Image from "@/components/ui/image/image.svelte";
  import Typography from "@/components/ui/typography/typography.svelte";
  import ProfileEditDialog from "./profile-edit-dialog.svelte";

  import AnonymouseUser from "@/images/anonymous.jpg?raw";
  import CoinIcon from "@/images/coin.svg";
  import DashboardIcon from "@/images/dashboard.svg";
  import EditIcon from "@/images/edit.svg";
  import LogoutIcon from "@/images/logout.svg";

  const t = (key: string, options?: any): string | object =>
    $i18n.t(key, { ns: "common", ...options });

  let openProfileEdit = $state(false);
</script>

<div class="rounded-[8px] border border-dark-gray bg-light-black p-4">
  <div>
    <div class="flex flex-wrap items-center justify-between gap-3">
      <div class="flex items-center gap-3">
        {#if $user?.image}
          <img
            src={$user.image}
            alt={t("profile_menu.user_avatar") as string}
            class="h-10 w-10 rounded-[8px] object-cover" />
        {:else}
          <Image
            src={AnonymouseUser}
            class="h-12 w-12 rounded-full object-cover"
            alt={t("profile_menu.anonymous_avatar") as string} />
        {/if}
        <div class="flex flex-col gap-0">
          <Typography variant="large">{$user?.name}</Typography>
          <Typography variant="small" weight="medium" color="muted"
            >{$user?.email}</Typography>
        </div>
      </div>
      {#if $user?.roles.includes("booster")}
        <div
          class="flex h-10 min-w-20 items-center justify-center gap-2 rounded-[8px] border border-dark-gray bg-blue-gray p-2 lg:hidden">
          <Image
            src={CoinIcon}
            class="h-5 w-5"
            alt={t("profile_menu.coin_icon") as string} />
          <Typography>{($user?.balance ?? 0) / 100}</Typography>
        </div>
      {/if}
    </div>
    <div class="mb-6 mt-4 h-[1px] w-full bg-dark-gray"></div>
    <div class="ml-4 flex flex-col gap-5">
      <div class="flex items-center gap-2">
        <Image
          src={DashboardIcon}
          class="h-5 w-5"
          alt={t("profile_menu.dashboard_icon") as string} />
        <a href="/user/orders">
          <Typography variant="p">{t("profile_menu.dashboard")}</Typography>
        </a>
      </div>
      <div class="flex items-center gap-2">
        <Image
          src={EditIcon}
          class="h-5 w-5"
          alt={t("profile_menu.edit_icon") as string} />
        <button
          onclick={() => {
            openProfileEdit = true;
          }}>
          <Typography variant="p">{t("profile_menu.edit_profile")}</Typography>
        </button>
      </div>
      <div class="flex items-center gap-2">
        <Image
          src={LogoutIcon}
          class="h-5 w-5"
          alt={t("profile_menu.logout_icon") as string} />
        <a href="/auth/logout">
          <Typography variant="p">{t("profile_menu.logout")}</Typography>
        </a>
      </div>
    </div>
  </div>
</div>

<ProfileEditDialog
  bind:open={openProfileEdit}
  onOpenChange={() => {
    openProfileEdit = !openProfileEdit;
  }} />
